










































































































































































































































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import ProductSummaryItem from '@/web/components/products/ProductSummaryItem.vue';
import { formatCurrency } from '@/web/utils/format';
import { notify } from '@/web/utils/notify';
import ProductToggleSection from '@/web/components/products/ProductToggleSection.vue';
import ProductEditSection from '@/web/components/products/ProductEditSection.vue';
import HMCheckBox from '@/web/components/common/HMCheckBox.vue';
import { getStudentViewURL } from '@/web/router/custom-domain-utils';
import { debounce } from 'lodash';

export default Vue.extend({
  name: 'ProductSummary',
  components: {
    HMCheckBox,
    ProductSummaryItem,
    ProductToggleSection,
    ProductEditSection,
  },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
      teacherProduct: 'product/teacherProduct',
      teacherStudioUrl: 'user/teacherStudioUrl',
      teacherMagicCode: 'user/teacherMagicCode',
      emailProvider: 'setting/emailProvider',
      flodeskSegments: 'setting/flodeskSegments',
      mailChimpLists: 'setting/mailChimpLists',
      convertKitTags: 'setting/convertKitTags',
      isUsingConvertKit: 'setting/isUsingConvertKit',
      isUsingMailChimp: 'setting/isUsingMailChimp',
      isUsingFlodesk: 'setting/isUsingFlodesk',
      domain: 'setting/domain',
    }),
    useCustomDomainUrl: {
      get() {
        return this.$store.getters['setting/useCustomDomainUrl'];
      },
      set(value) {
        this.$store.dispatch('setting/setUseCustomDomainUrl', value);
      },
    },
    convertKitTagsMapped() {
      return this.convertKitTags.map(tag => {
        return {
          ...tag,
          id: `${tag.id}`,
        };
      });
    },
    isClassCard() {
      return this.productForm.product_type == 'punch_card';
    },
    hasValidCustomDomain() {
      if (!this.domain) return false;
      if (!this.domain.success) return false;

      return true;
    },
    domainName() {
      return this.domain?.domain;
    },
    productUri(): string {
      const productId = this.teacherProduct.id;
      if (this.useCustomDomainUrl && this.hasValidCustomDomain) {
        return encodeURI(`https://${this.domainName}/product/${productId}`);
      }
      if (process.env.VUE_APP_STUDIO_ON_SUBDOMAINS === 'true') {
        return encodeURI(
          getStudentViewURL(
            this.teacherStudioUrl,
            `/product/${productId}`,
            null
          )
        );
      } else {
        const host = window.location.host;
        const protocol = window.location.protocol;
        const uri = encodeURI(
          `${protocol}//${host}/${this.teacherStudioUrl}/product/${productId}`
        );
        return uri;
      }
    },
    purchaseUri(): string {
      const productId = this.teacherProduct.id;
      if (this.useCustomDomainUrl && this.hasValidCustomDomain) {
        return encodeURI(`https://${this.domainName}/buy/product/${productId}`);
      }
      if (process.env.VUE_APP_STUDIO_ON_SUBDOMAINS === 'true') {
        return encodeURI(
          getStudentViewURL(
            this.teacherStudioUrl,
            `/buy/product/${productId}`,
            null
          )
        );
      } else {
        const host = window.location.host;
        const protocol = window.location.protocol;
        const uri = encodeURI(
          `${protocol}//${host}/${this.teacherStudioUrl}/buy/product/${productId}`
        );
        return uri;
      }
    },
    isRecurringProduct() {
      return this.productForm.pricing_type === 'recurring';
    },
    priceSummary(): { option: number; price: string } {
      switch (this.productForm.pricing_type) {
        case 'fixed':
          return {
            option: 1,
            price: formatCurrency(
              this.productForm.price,
              this.productForm.currency
            ),
          };
        case 'recurring':
          if (this.productForm.recurring_type === 'multiple') {
            const filtered = Object.entries(
              this.productForm.recurring_options
            ).filter(x => x[1].available === true);
            const prices: string[] = [];
            filtered.forEach(item => {
              const option = `${formatCurrency(
                item[1].price,
                this.productForm.currency
              )} ${item[0]}`;
              prices.push(option);
            });
            return {
              option: 2,
              price: prices.join(', '),
            };
          }
          return {
            option: 2,
            price: formatCurrency(
              this.productForm.price,
              this.productForm.currency
            ),
          };
        default:
          return {
            option: 0,
            price: '',
          };
      }
    },
    productDetailsAreSet(): boolean {
      return !!this.productForm.product_name;
    },
    dripScheduleIsActive(): boolean {
      return this.productForm.product_schedule_type === 'fixed';
    },
    isBundle() {
      return this.productForm.product_type === 'bundle';
    },
    isPrivateSpace() {
      return this.productForm.product_type === 'private_space';
    },
    hasSchedule(): boolean {
      return !(this.isBundle || this.isClassCard || this.isPrivateSpace);
    },
    events(): number {
      return this.productForm.events.length ?? 0;
    },
    lessons(): number {
      return this.productForm.lessons.length ?? 0;
    },
    enrolment: {
      get(): boolean {
        return this.productForm.enrollment_enabled;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          enrollment_enabled: value,
        });
      },
    },
    comments_enabled: {
      get(): boolean {
        return this.productForm.comments_enabled;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          comments_enabled: value,
        });
      },
    },
    displayProductStats: {
      get(): boolean {
        return this.productForm.display_product_stats;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          display_product_stats: value,
        });
      },
    },
    enrollmentPurchaseLimit: {
      get(): number | null {
        return this.productForm.enrollment_purchase_limit;
      },
      set(value: string | null) {
        this.$store.dispatch('product/setProductForm', {
          enrollment_purchase_limit: value === '' ? null : value,
        });
      },
    },
    published: {
      get(): boolean {
        return this.productForm.published;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductFormPublished', value);
      },
    },
    visible: {
      get(): boolean {
        return this.productForm.visible;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          visible: value,
        });
      },
    },
    archived: {
      get(): boolean {
        return this.productForm.archived;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          archived: value,
        });
      },
    },
    contract: {
      get(): boolean {
        return this.productForm.contract;
      },
      set(value: number) {
        this.$store.dispatch('product/setProductForm', {
          contract: value,
        });
      },
    },
    termsAndConditions: {
      get(): boolean {
        return this.productForm.terms_and_conditions;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          terms_and_conditions: value,
        });
      },
    },
    mailchimpList: {
      get(): boolean {
        return this.productForm.mailchimp_list;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          mailchimp_list: value,
        });
      },
    },
    mailchimpTag: {
      get(): boolean {
        return this.productForm.mailchimp_tag;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          mailchimp_tag: value,
        });
      },
    },
    removeTagOnChurn: {
      get(): boolean {
        return this.productForm.remove_tag_on_churn;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          remove_tag_on_churn: value,
        });
      },
    },
    flodeskSegment: {
      get(): boolean {
        return this.productForm.flodesk_segment;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          flodesk_segment: value,
        });
      },
    },
    convertkitTag: {
      get(): boolean {
        return this.productForm.convertkit_tag;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          convertkit_tag: value,
        });
      },
    },
    waitlistFlodeskSegment: {
      get(): boolean {
        return this.productForm.waitlist_flodesk_segment;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          waitlist_flodesk_segment: value,
        });
      },
    },
    waitlistMailchimpList: {
      get(): boolean {
        return this.productForm.waitlist_mailchimp_list;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          waitlist_mailchimp_list: value,
        });
      },
    },
    waitlistMailchimpTag: {
      get(): boolean {
        return this.productForm.waitlist_mailchimp_tag;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          waitlist_mailchimp_tag: value,
        });
      },
    },
    waitlistConvertkitTag: {
      get(): boolean {
        return this.productForm.waitlist_convertkit_tag;
      },
      set(value: boolean) {
        this.$store.dispatch('product/setProductForm', {
          waitlist_convertkit_tag: value,
        });
      },
    },
    showWaitlistFlodesk() {
      return (
        !this.productForm.enrollment_enabled &&
        this.productForm.waitlist_enabled &&
        this.flodeskSegments.length &&
        this.isUsingFlodesk
      );
    },
    showWaitlistMailChimp() {
      return (
        !this.productForm.enrollment_enabled &&
        this.productForm.waitlist_enabled &&
        this.mailChimpLists.length &&
        this.isUsingMailChimp
      );
    },
    showWaitlistConvertkit() {
      return (
        !this.productForm.enrollment_enabled &&
        this.productForm.waitlist_enabled &&
        this.convertKitTags.length &&
        this.isUsingConvertKit
      );
    },
  },
  data() {
    return {
      contracts: [],
    };
  },
  methods: {
    searchContracts: debounce(async function (query) {
      this.contracts = await this.$store.dispatch('contracts/getAllContracts', {
        q: query,
      });
    }, 300),
    navigateTo(tab: string): void {
      this.$parent.selectedTab = tab;
    },
    copy(id: string, value: string): void {
      const element = document.getElementById(id)!;
      const range = document.createRange();
      range.selectNode(element);
      const selection = window.getSelection()!;
      selection.removeAllRanges();
      selection.addRange(range);

      this.$copyText(value).then(() => {
        notify(this.$t('PRODUCTS.TOAST.COPIED') as string, value);
      });

      setTimeout(() => selection.removeAllRanges());
    },
    async loadCustomDomainInfo() {
      try {
        if (!this.hasValidCustomDomain) {
          await this.$store.dispatch('setting/getDomain');
        }
      } catch (_) {
        // it's ok, domain either not allowed or not found
      }
    },
  },
  async mounted() {
    this.loadCustomDomainInfo();
    this.$store.dispatch('setting/getEmailProvider');
    this.$store.dispatch('setting/getFlodeskSegments');
    this.$store.dispatch('setting/getMailChimpLists');
    this.$store.dispatch('setting/getConvertKitTags');
    this.contracts = await this.$store.dispatch(
      'contracts/getAllContracts',
      {}
    );
  },
});
